import { Button } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { logoutLiteTradeAction } from "../../../modules/LiteTrade/liteTradeActions.js";
import React, { useCallback, useEffect } from "react";
import { MobileProfileStyled } from "../styled/MobileProfileStyled";
import ProfileButtonEmail from "../../../modules/Account/components/ProfileButton/ProfileButtonEmail/ProfileButtonEmail";
import { ProfileVerifyAlert } from "../../../modules/Account/components/ProfileButton/ProfileVerifyAlert";
import { MOBILE_SLIDER_PAGES_IDS } from "../MobileSliderPages/mobileSliderPagesConstants";
import { openMobileSliderPageAction } from "../../mobileAppActions";
import { getPayoutLastDeposit, getPayoutParams } from "../../../modules/Account/accountSelectors";
import { getPayoutParamsAction } from "../../../modules/Account/accountActions";
import _ from "lodash";
import { useZendeskContext } from "../../../modules/Zendesk/zendeskContext";
import { useLangContext } from "../../../providers/LangProvider/LangProviderContext";
import {
    getWelcomeBonusAvailable,
    getWelcomeBannerOpened,
    getNewLifeRespawnBannerOpened, getIsRespawnAvailable
} from "../../../modules/Bonus/bonusesSelectors";
import MobileWelcomeBanner from "../MobileBonusBanner/MobileWelcomeBanner";
import MobileProfileCarousel from "./MobileProfileCarousel";
import MobileRespawnBanner from "../MobileBonusBanner/MobileRespawnBanner";
import MobileProfileLastDeposit from "./MobileProfileLastDeposit";

function MobileProfile() {
    const {isWebWidgetInited, openWebWidget} = useZendeskContext();
    const {getLangPath} = useLangContext();

    const dispatch = useDispatch();
    const payoutParams = useSelector(getPayoutParams);
    const welcomeBannerOpened = useSelector(getWelcomeBannerOpened);
    const welcomeBonusAvailable = useSelector(getWelcomeBonusAvailable);
    const newLifeRespawnBannerOpened = useSelector(getNewLifeRespawnBannerOpened);
    const isRespawnAvailable = useSelector(getIsRespawnAvailable);
    const lastDeposit = useSelector(getPayoutLastDeposit);

    useEffect(() => {
        dispatch(getPayoutParamsAction());
    }, [dispatch]);

    const handleVerifyButtonClick = useCallback(() => {
        dispatch(openMobileSliderPageAction(MOBILE_SLIDER_PAGES_IDS.VERIFY));
    }, [dispatch]);

    const handleSettingsClick = useCallback(() => {
        dispatch(openMobileSliderPageAction(MOBILE_SLIDER_PAGES_IDS.SETTINGS));
    }, [dispatch]);

    const handleLogoutClick = useCallback(() => {
        dispatch(logoutLiteTradeAction());
    }, [dispatch]);

    return <MobileProfileStyled>
        <ProfileButtonEmail/>
        <MobileProfileCarousel>
            {!!(welcomeBonusAvailable && welcomeBannerOpened) && <MobileWelcomeBanner/>}
            {!!(isRespawnAvailable && newLifeRespawnBannerOpened) && <MobileRespawnBanner/>}
        </MobileProfileCarousel>
        {!!lastDeposit && <MobileProfileLastDeposit/>}
        <ProfileVerifyAlert show={!_.isEmpty(payoutParams) && !payoutParams.verify}
                            handleVerifyButtonClick={handleVerifyButtonClick}
                            className="mt-3"/>
        <Button variant="outline-info" onClick={handleSettingsClick} className="my-3">
            {getLangPath('menu.settings')}
        </Button>
        <Button variant="outline-info" disabled={!isWebWidgetInited} className="my-3" onClick={openWebWidget}>
            {getLangPath('menu.support')}
        </Button>
        <Button variant={'outline-info'} onClick={handleLogoutClick} className="my-3 negative">
            {getLangPath('menu.log_out')}
        </Button>
    </MobileProfileStyled>
}

export default MobileProfile;
